<div>
  <span [className]="badgeClass">
    {{('mydspace.status.' + badgeContent) | translate}}
  </span>
</div>
